$(function() {
  var search_string = getQueryStringValue("q");
  var search_data = search_string.split("+");
   
    
  if (typeof search_data !== 'undefined' && search_data.length > 1) {

    var year  = search_data[0];
    var make  = search_data[1];
    var model = search_data[2];

    
     
    
    //change search title and search dropbox selected
    
    $('.page_heading').html(year+' '+make+' '+model+' Automotive Lighting');
    
    var vachile_name = 'Your Vehicle: ' +year+' '+make+' '+model;
    var vachile_url  = window.location.href;

    $('#myvachile_name').html(vachile_name);
    sessionStorage.setItem("vachile_name", vachile_name);
    sessionStorage.setItem("vachile_url", vachile_url);

    $(window).load(function() {
      var time = new Date().getTime();
      var json_url = "//ledlightstreet.com/cdn/shop/t/46/assets/hindnationv4.json?v="+time;

      $('#make').prop('disabled', false);
      getmakefromyear(json_url, year);

      $('#model').prop('disabled', false);
      getmodelfrommake1(json_url, year, make);

    });

    function getmodelfrommake1(json_url, year, make){
      var allmodel = "<option value=''>--Model--</option>";
      $.getJSON(json_url, function( data ) {
        $.each( data[year][make], function( key, val ) {
          //console.log( "<option value='" + key + "'>" + val + "</option>");
          allmodel += "<option value='" + key + "'>" + val + "</option>";
        });

        $("#model option").remove();
        $("#model").append(allmodel);

        $('#year').val(year);
        $('#make').val(make);
        $('#model').val(model);

      });
    }
    //   window.setTimeout(function(){
    //     $('#year').val(year);
    //     $('#make').val(make);
    //     $('#model').val(model);

    //   }, 3000);


    var time = new Date().getTime();

    json_url_new = "https://cdn.shopify.com/s/files/1/0249/0207/4421/files/"+year+"-fitment-categories-data-halo-30aprail2018.json?"+time;
    var con_filter = year+make+model;
    get_categories_section(year, make, model);

    var html="";

    function get_categories_section(year,make,model){

      var sortnum = 9;

      var linkval = '';
      var htm= '';
      var html1 ='';
    
   var htm1='';
      $.getJSON(json_url_new, function( data ) {
      
        $.each( data[year][make][model], function( key, val ) {
          html += "<div class='product_name'>"+ key +"</div><ol id='listitems"+sortnum+"' class='search-results'>";
          $.each( val, function( key1, val1 ) {
            $.each( val1, function( key11, val11 ) {

              if(/^[a-zA-Z0-9-() ]*$/.test(key11) == false) {
                var str = key11;
                arr = str.split(',');
                name= key1 + arr[0];
                linkval = arr[1];
              }else{
                name = key1;
                linkval = key11;
              }
                          
 
             if(name == 'Factory Replacement HID Ballast'){
                return true;
              }           

              if(linkval == '9006'){
                linkval = '9006 (HB4)';
              }
              else if(linkval == '9005'){
                linkval = '9005 (HB3)';
              }
              else if(linkval == '9007'){
                linkval = '9007 (HB5)';
              }
              else if(linkval == 'H4'){
                linkval = 'H4 (9003)';
              }
              else if(linkval == '9004'){
                linkval = '9004 (HB1)';
              }
              else if(linkval == 'H13'){
                linkval = 'H13 (9008)';
              }
              else if(linkval == '194'){
                linkval = '194 (168)';
              }
              else if(linkval == '212-2'){
                linkval = '212-2 (44mm)';
              }
              else if(linkval == '6418'){
                linkval = '6418 (36mm)';
              }
              else if(linkval == '3022'){
                linkval = '3022 (31mm)';
              }

              linkval = linkval.split("(");

              linkval = linkval[0];
              
             
              
              

              if(linkval == 'D1S'){
                html += "<li data-position='1' ><span class='icon-img' value='"+name+"'>"+ htm +"</span><a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + name +"'>"+ name +" <span class='readmore'>Type: "+ linkval +"<span class='arrrow'></span></span></a></li>";  
              }
              else if(linkval == 'D1R'){
                html += "<li data-position='2' ><span class='icon-img' value='"+name+"'>"+ htm +"</span><span class='icon-img'><img src=''></span><a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + name +"'>"+ name +" <span class='readmore'>Type: "+ linkval +"<span class='arrrow'></span></span></a></li>";  
              }
              else if(linkval == 'D2S'){
                html += "<li data-position='3' ><span class='icon-img' value='"+name+"'>"+ htm +"</span><a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + name +"'>"+ name +" <span class='readmore'>Type: "+ linkval +"<span class='arrrow'></span></span></a></li>";  
              }
              else if(linkval == 'D2R'){
                html += "<li data-position='4' ><span class='icon-img' value='"+name+"'>"+ htm +"</span><a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + name +"'>"+ name +" <span class='readmore'>Type: "+ linkval +"<span class='arrrow'></span></span></a></li>";  
              }
              else if(linkval == 'D3S'){
                html += "<li data-position='5' ><span class='icon-img' value='"+name+"'>"+ htm +"</span><a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + name +"'>"+ name +" <span class='readmore'>Type: "+ linkval +"<span class='arrrow'></span></span></a></li>";  
              }
              else if(linkval == 'D3R'){
                html += "<li data-position='6' ><span class='icon-img' value='"+name+"'>"+ htm +"</span><a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + name +"'>"+ name +" <span class='readmore'>Type: "+ linkval +"<span class='arrrow'></span></span></a></li>";  
              }
              else if(linkval == 'D4S'){
                html += "<li data-position='7' ><span class='icon-img' value='"+name+"'>"+ htm +"</span><a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + name +"'>"+ name +"<span class='readmore'>Type: "+ linkval +"<span class='arrrow'></span></span></a></li>";  
              }
              else if(linkval == 'D4R'){
                html += "<li data-position='8'><span class='icon-img' value='"+name+"'>"+ htm +"</span><a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + name +"'>"+ name +" <span class='readmore'>Type: "+ linkval +"<span class='arrrow'></span></span></a></li>";  
              } else {

                html += "<li data-position='"+ sortnum +"' class='iconli'><span class='icon-img' value='"+name+"'>"+ htm +"</span><a href='/collections/types?q="+linkval+"' title='"+ year + " " + make + " " + model + " " + name +"'>"+ name +"<span class='readmore'>Type: "+ linkval +"<span class='arrrow'></span></span></a></li>";
				 	
              }           

            });
            ++sortnum;

          });

          html += "</ol>";
         			
        });
       
           
        $("#searchresults ul").html(html);
        
       
      
        
        /******************************************Back img icon in serch result***************************************/
        
        $('#searchresults ul').find('.icon-img').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/back_up_light.png?v=1600769669)")
        $('#searchresults ul').find('.icon-img[value="License Plate Light Bulb"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/license_plate_lamp.png?v=1600769669)")
        $('#searchresults ul').find('.icon-img[value="Fog Light Bulb Front"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/fog_light.png?v=1600769669)")
        $('#searchresults ul').find('.icon-img[value="Vanity Mirror Light Bulb"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/center_third_1.png?v=1600769669)")
        $('#searchresults ul').find('.icon-img[value="Fog Light"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/fog_light.png?v=1600769669)")
        $('#searchresults ul').find('.icon-img[value="Low Beam Headlight"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/low_beam.png?v=1600769670)")
        $('#searchresults ul').find('.icon-img[value="High Beam Headlight"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/high_beam.png?v=1600769669)")
        $('#searchresults ul').find('.icon-img[value="Interior Door Light Bulb"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/interior_dome.png?v=1600769669)")
        $('#searchresults ul').find('.icon-img[value="Parking Light Bulb"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/front_parking.png?v=1600769669)")    
        $('#searchresults ul').find('.icon-img[value="Dome Light Bulb"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/interior_dome.png?v=1600769669)")
        $('#searchresults ul').find('.icon-img[value="Trunk Light Bulb"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/trunklight.png?v=1600924979)")
		$('#searchresults ul').find('.icon-img[value="Glove Box Light Bulb"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/center_third_1.png?v=1600769669)")
        $('#searchresults ul').find('.icon-img[value="Map Light Bulb"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/center_third_1.png?v=1600769669)")        
        $('#searchresults ul').find('.icon-img[value="Side Marker Light Bulb Front"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/front_side_marker_lamp.png?v=1600769669)")
        $('#searchresults ul').find('.icon-img[value="Turn Signal Light Bulb Rear"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/Rear-Turn-Signal.png?v=1600924979)")
 		$('#searchresults ul').find('.icon-img[value="Brake Light Bulb"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/stop_break.png?v=1600769669)")
		$('#searchresults ul').find('.icon-img[value="Trunk or Cargo Area Light"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/trunklight.png?v=1600924979)")
        $('#searchresults ul').find('.icon-img[value="Low Beam & High Beam Headlight (Factory Equipped HID)"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/dual_beam.png?v=1600934789)")
		$('#searchresults ul').find('.icon-img[value="Low Beam & High Beam Headlight"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/dual_beam.png?v=1600934789)")		
        $('#searchresults ul').find('.icon-img[value="Daytime Running Light Bulb"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/center_third_1.png?v=1600769669)")
		$('#searchresults ul').find('.icon-img[value="Parking Light Bulb  (AWD)"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/front_parking.png?v=1600769669)")
		$('#searchresults ul').find('.icon-img[value="Parking Light Bulb  (Limited)"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/front_parking.png?v=1600769669)")
		$('#searchresults ul').find('.icon-img[value="Parking Light Bulb"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/front_parking.png?v=1600769669)")	
        $('#searchresults ul').find('.icon-img[value="Side Marker Light Bulb Rear"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/Rear-Side-Marker-Lamp.png?v=1600769669)")
		$('#searchresults ul').find('.icon-img[value="Tail Light Bulb Inner"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/tail_light.png?v=1600924995)")
        $('#searchresults ul').find('.icon-img[value="Turn Signal Light Bulb Front  (AWD)"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/front_turn_signal.png?v=1600769669)")
		$('#searchresults ul').find('.icon-img[value="Turn Signal Light Bulb Front  (Limited)"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/front_turn_signal.png?v=1600769669)")
		$('#searchresults ul').find('.icon-img[value="Tail Light Bulb Outer"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/tail_light.png?v=1600924995)")
		$('#searchresults ul').find('.icon-img[value="Tail Light Bulb"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/tail_light.png?v=1600924995)")
		$('#searchresults ul').find('.icon-img[value="Turn Signal Light Bulb Front"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/front_turn_signal.png?v=1600769669)")		     
        $('#searchresults ul').find('.icon-img[value="Headlight Bulb Low Beam (Factory Equipped Halogen)"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/low_beam.png?v=1600769670)")
        $('#searchresults ul').find('.icon-img[value="Headlight Bulb Low Beam (Factory Equipped HID)"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/low_beam.png?v=1600769670)")
        $('#searchresults ul').find('.icon-img[value="Turn Signal Light Bulb Front (Check owners manual for correct bulb size)"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/front_turn_signal.png?v=1600769669)")		          
        $('#searchresults ul').find('.icon-img[value="Turn Signal Light Bulb Front (Check owners manual for correct bulb size)"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/front_turn_signal.png?v=1600769669)")		           
        $('#searchresults ul').find('.icon-img[value="Turn Signal Light Bulb Front Outer"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/front_turn_signal.png?v=1600769669)")	  
        $('#searchresults ul').find('.icon-img[value="Turn Signal Light Bulb Front Inner"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/front_turn_signal.png?v=1600769669)")
        $('#searchresults ul').find('.icon-img[value="Turn Signal Light Bulb Front  (with sealed beam headlamps)"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/front_turn_signal.png?v=1600769669)")
        $('#searchresults ul').find('.icon-img[value="Turn Signal Light Bulb Front (Factory Equipped Halogen)"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/front_turn_signal.png?v=1600769669)")
        $('#searchresults ul').find('.icon-img[value="Parking Light Bulb (Factory Equipped Halogen)"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/front_parking.png?v=1600769669)")
        $('#searchresults ul').find('.icon-img[value="Parking Light Bulb  (with sealed beam headlamps)"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/front_parking.png?v=1600769669)")
		$('#searchresults ul').find('.icon-img[value="Headlight Bulb High Beam and Low Beam  (with sealed beam headlamps)"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/dual_beam.png?v=1600934789)")		        
        $('#searchresults ul').find('.icon-img[value="Headlight Bulb High Beam and Low Beam (Factory Equipped Halogen)"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/dual_beam.png?v=1600934789)")
        $('#searchresults ul').find('.icon-img[value="Side Marker Light Bulb Front  (with sealed beam headlamps)"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/front_side_marker_lamp.png?v=1600769669)")		        
        $('#searchresults ul').find('.icon-img[value="Side Marker Light Bulb Front (Factory Equipped Halogen)"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/front_side_marker_lamp.png?v=1600769669)")		        
		$('#searchresults ul').find('.icon-img[value="Courtesy Light Bulb"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/courtesy_light.png?v=1601528474)")		        
		$('#searchresults ul').find('.icon-img[value="Headlight Bulb Low Beam  (  (w/HID headlamps))"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/low_beam.png?v=1600769670)")
		$('#searchresults ul').find('.icon-img[value="Headlight Bulb High Beam  (  (w/HID headlamps))"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/high_beam.png?v=1600769669)")
		$('#searchresults ul').find('.icon-img[value="Headlight Bulb Low Beam  (with projector-type headlamps)"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/low_beam.png?v=1600769670)")
        $('#searchresults ul').find('.icon-img[value="Headlight Bulb Low Beam  (without projector-type headlamps)"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/low_beam.png?v=1600769670)")
        $('#searchresults ul').find('.icon-img[value="Headlight Bulb High Beam  (with projector-type headlamps)"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/high_beam.png?v=1600769669)")
        $('#searchresults ul').find('.icon-img[value="Headlight Bulb High Beam  (without projector-type headlamps)"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/high_beam.png?v=1600769669)")
 		$('#searchresults ul').find('.icon-img[value="Headlight Bulb High Beam and Low Beam (Factory Equipped HID)"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/dual_beam.png?v=1600934789)")
        $( '#searchresults ul :contains("Headlight Bulb High Beam and Low Beam")').find('.icon-img').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/dual_beam.png?v=1600934789)")
        
         $('#searchresults ul').find('.icon-img[value="Headlight Bulb High Beam"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/high_beam.png?v=1600769669)")
 		 $('#searchresults ul').find('.icon-img[value="Headlight Bulb Low Beam"]').css("background-image","url(https://cdn.shopify.com/s/files/1/0249/0207/4421/files/low_beam.png?v=1600769670)")
 		
        /**=================____Sorting_Start____=================**/

        //1. Assign attributes(data-position) for sort parent items
        $('#searchresults .search-result').each(function(i) {
          var j =10+i;
          if ($(this).find('.product_name').html().indexOf('FORWARD LIGHTING') > -1){
            $(this).attr('data-position',1);   
          } else {
            $(this).attr('data-position',j);
          }
        });

        //2. TO Sort Parent element
        $("#searchresults .search-result").each(function(){

          $("#searchresults li.search-result").sort(sort_li).appendTo("#searchresults ul");  

        });

        //3. TO Sort chield element
        $("#searchresults .search-results").each(function(){

          var childid = $(this).attr('id');
          $("#"+childid+" li").sort(sort_li).appendTo("#"+childid);  

        });

        function sort_li(a, b){
          return ($(b).data('position')) < ($(a).data('position')) ? 1 : -1;
        }

        /**=================____Sorting_End____=================**/

      });

    }

    setInterval(function(){
      $('#searchresults li.search-result ol li a').each(function(){
        var line_text = $(this).text();
        //var split_text = line_text.replace('BULB','').replace('bulb','').replace('Bulb','').replace('(w/HID headlamps)','(Factory equipped with HID)').replace('(w/halogen capsule headlamps)','(Factory equipped with Halogen)').replace('High Beam and Low Beam Headlight','Low & High Beam Headlight').replace('Front Fog Light','Fog Light').replace('License Light','License Plate Light');
        var split_text = line_text.replace('BULB','').replace('bulb','').replace('(w/HID headlamps)','(Factory equipped with HID)').replace('(w/halogen capsule headlamps)','(Factory equipped with Halogen)').replace('High Beam and Low Beam Headlight','Low & High Beam Headlight').replace('Front Fog Light','Fog Light').replace('License Light','License Plate Light');
        $(this).text(split_text);
      });
    },100);

  }

  function getQueryStringValue (key) {
    return unescape(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + escape(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));  
  }
  

});

// serach dropdown js
$(function() {

  //Category
  $('#category').change(function(){
    var category = $(this).val();
      if(category == 'motorcycle'){
        var json_url = "{{ 'selectbox-motorcycle.js' | asset_url }}";
      }else if(category == 'snowmobile'){
        var json_url = "{{ 'selectbox-snowmobile.js' | asset_url }}";
      }else{
        var json_url = "//ledlightstreet.com/cdn/shop/t/48/assets/hidnationv5.json?v=118122430411503342021756806973";
      }

      $.getJSON(json_url, function( data ) {

        var allyear = "<option value=''>Year</option>";
        $.each( data, function( key, val ) {
          allyear += "<option value='" + key + "'>"+ key +"</option>";
          //console.log(allyear);
        });

        $("#year option").remove();
        $("#year").append(allyear);

        //SORT BY DESC
        var selectList = $('#year option[value!=""]');
        selectList.sort(function(x,y){return y.value - x.value});
        $('#year').append(selectList);

        $('#make,#model').prop('disabled', true);

      });
  });

  //YEAR  
//   $('#year').prop('disabled', true);
//   $(window).on('load',function(){
//     $('#year').prop('disabled', false);
//     $('.year-dropdown .coll-filter').each(function (index, element) {
//       $(this).parent().after().append("<div class='scrollableList scrollableList_one'><div class='selectedOption selectedOption_one'></div><ul></ul></div>");

//       $(element).each(function (idx, elm) {
//         $('option', elm).each(function (id, el) {
//           $('.scrollableList_one ul:last').append('<li>' + el.text + '</li>');
//         });
//         $('.scrollableList_one ul').hide();
//         //$('.makeMeUl').children('div.selectedOption_one').text("Select");
//       });
//       $('.scrollableList_one:last').children('div.selectedOption_one').text("Year");
//     });

//     $('.selectedOption_one').on('click', function () {
//       $('.scrollableList_two ul').hide();
//       $('.scrollableList_three ul').hide();
//       $('.scrollableList_two').remove();
//       $('#make').show();
//       $('#make').prop('disabled', true);
//       $(this).parents('.sel-year').toggleClass('active');
//       $(this).next('ul').slideToggle(200);
//       $('.selectedOption').not(this).next('ul').hide();
//     });

//     $('.scrollableList_one ul li').on('click', function () {
//       var selectedLI = $(this).text();
//       $(this).parent().prev('.selectedOption_one').text(selectedLI);
//       $("#year").val(selectedLI).change();          
//       $(this).parent('ul').hide();
//       $(this).parents('.sel-year').removeClass('active');
//     });

//     $('.scrollableList_one').show();
//     $('.year-dropdown .coll-filter').hide();
//   });  
  
  
  $('#year').change(function(){
    // your code should be here
      var year = $(this).val();
      var category = $('#category').val();

      if(category == 'motorcycle'){
        var json_url = "{{ 'selectbox-motorcycle.js' | asset_url }}";
      }else if(category == 'snowmobile'){
        var json_url = "{{ 'selectbox-snowmobile.js' | asset_url }}";
      }else{
        var json_url = "//ledlightstreet.com/cdn/shop/t/48/assets/hidnationv5.json?v=118122430411503342021756806973";
      }

      if(year){
        $('#make').prop('disabled', false);
        $('#model').val('').prop('disabled', true);
        getmakefromyear(json_url, year);

      }else{
        $('#make').prop('disabled', true);
        $('#model').prop('disabled', true);
      }
  });

  //MAKE
  
  $('#make').change(function(){
    // your code should be here
      
      var category = $('#category').val();
      if(category == 'motorcycle'){
        var json_url = "{{ 'selectbox-motorcycle.js' | asset_url }}";
      }else if(category == 'snowmobile'){
        var json_url = "{{ 'selectbox-snowmobile.js' | asset_url }}";
      }else{
        var json_url = "//ledlightstreet.com/cdn/shop/t/48/assets/hidnationv5.json?v=118122430411503342021756806973";
      }
      
      var make = $(this).val();
      var year = $("#year").val();

      if(make){
        getmodelfrommake(json_url, year, make);
        $('#model').prop('disabled', false);
      }else{
        $('#model').prop('disabled', true);
      }


  });
  
  $('#model').change(function(){
    var model = $(this).val();
	if(model){
      $('.sel-model').removeClass('model-dropdown');
      var model = $("#model").val();
      var year = $("#year").val();
      var make = $("#make").val();

      var model = encodeURIComponent(model);
      var year = encodeURIComponent(year);
      var make = encodeURIComponent(make);
      
//       window.location.href = '/search?q='+year+"+"+make+"+"+model;
//       window.location.href = '/pages/search-result?q='+year+"+"+make+"+"+model;
      
    }else{
      $('.sel-model').addClass('model-dropdown');
    }
  });

  //MODEL
  $("#findBtnSubmit").click(function(){
    //jQuery('#model').change(function(){
      // your code should be here
      //var model = $(this).val();
      var model = $("#model").val();
      var year = $("#year").val();
      var make = $("#make").val();
      
      var model = encodeURIComponent(model);
      var year = encodeURIComponent(year);
      var make = encodeURIComponent(make);

      if(model){
//         window.location.href = '/search?q='+year+"+"+make+"+"+model;
//         window.location.href = '/pages/search-result?q='+year+"+"+make+"+"+model;
        
        var category = $('#category').val();
        if(category == 'motorcycle'){
          window.location.href = '/pages/motorcycle?q='+year+"+"+make+"+"+model;
        }else if(category == 'snowmobile'){
          window.location.href = '/pages/snowmobile?q='+year+"+"+make+"+"+model;
        }else{
          window.location.href = '/pages/search-result?q='+year+"+"+make+"+"+model;
        }

      } else if(make){
//         window.location.href = '/search?q='+year+"+"+make+"+"+model;
//         window.location.href = '/pages/search-result?q='+year+"+"+make+"+"+model;
        
        var category = $('#category').val();
        if(category == 'motorcycle'){
          window.location.href = '/pages/motorcycle?q='+year+"+"+make;
        }else if(category == 'snowmobile'){
          window.location.href = '/pages/snowmobile?q='+year+"+"+make;
        }else{
          window.location.href = '/pages/search-result?q='+year+"+"+make;
        }

      }
  });

  // var windowsize = $(window).width();
  // if (windowsize < 768) {
    $("#select-vehicle").click(function() {
      $('.search-dropdown').slideToggle();
    });
  // }

  
  

  
});

// var json_url = "//ledlightstreet.com/cdn/shop/t/46/assets/hidnationv5.json?v=64060676693577377791691473415";
var json_url = "//ledlightstreet.com/cdn/shop/t/48/assets/hidnationv5.json?v=118122430411503342021756806973";



$.getJSON(json_url, function( data) {

  var allyear = "";

  $.each( data, function( key, val ) {
    //console.log( "<option value='" + key + "'>"+ key +"</option>");
    
   var idmake = $('.dropmenu-car-makes ul li a').attr('data-url');
   
      allyear += "<option value='" + key + "'>"+ key +"</option>";
      });


  $("#year").append(allyear);
 
  
  //SORT BY DESC
  var selectList = $('#year option[value!=""]');
  selectList.sort(function(x,y){return y.value - x.value});
  $('#year').append(selectList);
  

});

function getmakefromyear(json_url, year){

  var allmake = "<option value=''>--Make--</option>";

  $.getJSON(json_url, function( data ) {

    $.each( data[year], function( key, val ) {
      //console.log( "<option value='" + key + "'>" + key + "</option>");
      allmake += "<option value='" + key + "'>" + key + "</option>";
    });

    $("#make option").remove();
    $("#make").append(allmake);

  });

}




function getmodelfrommake(json_url, year, make){
  var allmodel = "<option value=''>--Model--</option>";
  
  $.getJSON(json_url, function( data ) {
    $.each( data[year][make], function( key, val ) {
      //console.log( "<option value='" + key + "'>" + val + "</option>");
      allmodel += "<option value='" + key + "'>" + val + "</option>";
   
    });
  
       
    $("#model option").remove();
    $("#model").append(allmodel);

  });
}


// $('ul.tabs li a').on('click', function (event) {
 
    
//     $('.tabs li').removeClass('active');
//     $(this).parent().addClass('active');
//     $('.tabs-content div').hide();
//     $($(this).attr('href')).show();
  
// });


// $('ul.tabs li a:first').trigger('click'); // Default


$(document).ready(() => {
  let url = location.href.replace(/\/$/, "");
 
  if (location.hash) {
    const hash = url.split("#");
    $('#tabs a[href="#'+hash[0]+'"]').tab("show");
    url = location.href.replace(/\/#/, "#");
    history.replaceState(null, null, url);
    setTimeout(() => {
      $(window).scrollTop(0);
    }, 400);
  } 
   
  $('a[data-toggle="tab"]').on("click", function() {
    let newUrl;
    const hash = $(this).attr("href");

    newUrl = url.split("#")[0] + hash;

    newUrl += "";
    history.replaceState(null, null, newUrl);
  });
});      